import { defineStore } from 'pinia';

export const useShowInlineNotificationsStore = defineStore('showInlineNotificationsStore', {
  state: () => ({
    visible: false,
    message: '',
  }),
  actions: {
    setInlineNotificationsVisibility(payload) {
      this.visible = payload.visible;
      this.message = payload.message;
    },
  },
});
